import { styled } from '../../../theme';
import { Box } from '../../Box';

export const MAX_SM = 750;
export const MAX_MD = 970;
export const MAX_LG = 1170;

export const Container = styled(Box)(({ theme }) => ({
    marginRight: 'auto',
    marginLeft: 'auto',
    paddingLeft: 15,
    paddingRight: 15,

    [theme.breakpoints.up('sm')]: {
        width: MAX_SM,
    },
    [theme.breakpoints.up('md')]: {
        width: MAX_MD,
    },
    [theme.breakpoints.up('lg')]: {
        width: MAX_LG,
    },
}));
